import {
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAIL,
  USER_ADD_REQUEST,
  USER_ADD_SUCCESS,
  USER_ADD_FAIL,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAIL
} from "../constants/userListConstants";
const initialState = {
  userListData: [],
  pagination: null,
  loading: false,
  error: null,
};

export const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LIST_REQUEST:
    case USER_ADD_REQUEST:
    case USER_UPDATE_REQUEST:
      return { ...state, loading: true };

    case USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userListData: action.payload.users,
        pagination: action.payload.pagination,
      };

    case USER_ADD_SUCCESS:
    case USER_UPDATE_SUCCESS:
      return { ...state, loading: false };

    case USER_LIST_FAIL:
    case USER_ADD_FAIL:
    case USER_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
